<template>
    <tabs :options="{ useUrlFragment: false }">
        <tab name="Long Banners">
            <div class="containter eventhall_flags">
        <div class="form-group row">
            <div class="col-lg-12">

                <div id ="multiple_images">
                    <input
                        placeholder="Upload Multiple Long Banners"
                        type="file"
                        class="form-control"
                        @change="updateBannerLong"
                        multiple="multiple"
                        accept="image/jpeg"
                        
                      >
                      <span>Upload Multiple Long Banners (Max Limit 14 & Suggested Resolution:720X1800 and JPEG only) </span>
                         
                </div>
       
            </div>
            <div class="image-list">
                        <div class="image-item" v-for="file in item.banner_long" v-bind:key="file">
                        <img :src="IMAGE_URL + file.key" alt="Image 1" >
                        <div class="image-details">
                            <span class="image-name">{{getFileName(file.key)}}</span>
                            <button type="button" class="remove-btn" @click="removeBannerLongAsset($event, file.key)">Remove</button>
                        </div>
                        </div>
                </div>
        </div>


            </div>
        </tab>
        <tab name="Small Banners">
            <div class="containter eventhall_flags">

                <div class="form-group row">
                <div class="col-lg-12">

                    <div id ="multiple_images">
                        <input
                            placeholder="Upload Multiple Small Banners"
                            type="file"
                            class="form-control"
                            @change="updateBannerSmall"
                            multiple="multiple"
                            accept="image/jpeg"
                            
                        >
                        <span>Upload Multiple Small Banners (Max Limit 13 & Suggested Resolution:1800X600 and JPEG only) </span>
                    </div>
        
                </div>
                <div class="image-list">
                    <div class="image-item" v-for="file in item.banner_small" v-bind:key="file">
                    <img :src="IMAGE_URL + file.key" alt="Image 1" >
                    <div class="image-details">
                        <span class="image-name">{{getFileName(file.key)}}</span>
                        <button type="button" class="remove-btn" @click="removeBannerSmallAsset($event, file.key)">Remove</button>
                    </div>
                    </div>
                </div>
        </div>


            </div>
        </tab>
    </tabs>
    <FlashMessage group="exhibition_area_banner" />

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import constants from "@/config/constants";
   
import { upload, remove } from "@/services/FileUploader";
import ObjectID from 'bson-objectid';
export default{
    name: "BannersTab",
    data() {
        return {
            IMAGE_URL:constants.IMAGE_URL,
            moduleId: ObjectID(),
        
        }
    },
    beforeUnmount() {
      this.resetState();
      delete this.$flashMessage.groups.exhibition_area_theme;
      delete this.$flashMessage.groups.exhibition_area_banner;

      
    },
    computed: {
        ...mapGetters("ExhibitionAreasSingle", [
            "item",
        ])
    },
    methods: {
        ...mapActions("ExhibitionAreasSingle", [
            'setBannerLong',
            'removeBannerLong',
            "setBannerSmall",
            "removeBannerSmall",
            "resetState"
        ]),
        getFileName(str){
                let stringNew =  str.split("/").pop();
                return stringNew.slice(-25);
        },
        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
       
        async updateBannerLong(e){
                try {
                    
                    let image_qty = 14;
                    let totalDocs = this.item.banner_long.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Long Banners in the Exhibitionn Hall`);
                        return;
                    }
                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                        
                        
                        
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "events", '720X1800', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();

                        this.setBannerLong({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'exhibition_area_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
        },
        removeBannerLongAsset(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeBannerLong(id);
                    })
                }
            });
        },
        async updateBannerSmall(e){
                try {
                    
                    let image_qty = 13;
                    let totalDocs = this.item.banner_small.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Small Banner in the Exhibitionn Hall`);
                        return;
                    }

                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "events", '1800X600', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();

                        this.setBannerSmall({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'exhibition_area_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
        },
        removeBannerSmallAsset(e, id) {
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeBannerSmall(id);
                    })
                }
            });
        },
        errCb(e){
            this.$flashMessage.show({
                group : 'exhibition_area_banner',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        }

       
        
       
       
        
        
        
        
        
    }
}
</script>
